import type { CityConfig } from "../city-template/types";

export const eastonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Maryland Department of Health Vital Statistics Administration. Online, mail, or in-person at the Baltimore vital records office.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the Maryland Department of Health Vital Statistics. Required for estate, legal, and survivor benefit matters.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request certified marriage records from the Talbot County Circuit Court Clerk. Required for name change passport applications.", url: "https://www.talbotcounty-md.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Talbot County Circuit Court. Required for name change passport corrections.", url: "https://www.talbotcounty-md.gov/" },
  ],
  city: "Easton",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "easton",
  route: "/cities/easton-md",
  title: "Emergency Passport Easton, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Easton, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Easton, St. Michaels, Oxford, and Cambridge residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Easton, MD",
  heroSubtitle: "Easton travelers — from Eastern Shore families to historic district residents to waterfront boaters — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Talbot County and Maryland's Eastern Shore.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Charming view of Easton Maryland historic district along Washington Street with elegant colonial-era brick buildings, boutique shops, tree-lined streets, small-town Eastern Shore charm, warm afternoon golden hour lighting, professional Chesapeake Bay region photography, no visible text or people, clean architectural details and green landscaping, Talbot County atmosphere\u0026width=1800\u0026height=700\u0026seq=easton-md-hero-001\u0026orientation=landscape",
  heroImageAlt: "View of Easton Maryland historic district along Washington Street with charming colonial-era buildings",
  geoPosition: "38.7743;-76.0763",
  geoPlacename: "Easton, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 1.5–2 hours from Easton via US-50 W",
  },
  nearbyCitiesZips: [
    { name: "Easton", zips: "21601, 21606" },
    { name: "St. Michaels", zips: "21663" },
    { name: "Oxford", zips: "21654" },
    { name: "Trappe", zips: "21673" },
    { name: "Cambridge", zips: "21613" },
    { name: "Hurlock", zips: "21643" },
    { name: "Denton", zips: "21629" },
    { name: "Preston", zips: "21655" },
    { name: "Federalsburg", zips: "21632" },
    { name: "Chestertown", zips: "21620" },
    { name: "Rock Hall", zips: "21661" },
    { name: "Grasonville", zips: "21638" },
    { name: "Queenstown", zips: "21658" },
    { name: "Stevensville", zips: "21666" },
    { name: "Annapolis", zips: "21401, 21402, 21403, 21404, 21405, 21409, 21411, 21412" },
    { name: "Salisbury", zips: "21801, 21802, 21803, 21804" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Easton and Eastern Shore departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-sailboat-line", title: "Eastern Shore Specialist", desc: "Serving Talbot County waterfront communities and Chesapeake Bay travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no 2-hour trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Annapolis, MD", route: "/cities/annapolis" },
    { name: "Emergency passport help in Salisbury, MD", route: "/cities/salisbury-md" },
    { name: "Urgent passport services in Ocean City, MD", route: "/cities/ocean-city" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Easton, Maryland remotely via secure registered courier. We do not have a walk-in office in Easton — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is especially important for Eastern Shore residents, as the drive to the nearest passport agency is approximately 1.5–2 hours each way across the Chesapeake Bay.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, MD 20814",
  fpcOfficeDistance: "Serving Easton, St. Michaels, Oxford, Trappe, and greater Talbot County and the Eastern Shore",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Easton and the Eastern Shore. From the historic Easton downtown along Washington Street to the charming waterfront communities of St. Michaels and Oxford, from the Cambridge area to the crossroads of Denton and Hurlock — we serve all of Talbot County and the Eastern Shore.",
  nearbyCitiesIntro: "We serve Easton and nearby communities including St. Michaels, Oxford, Trappe, Cambridge, Hurlock, Denton, Preston, Federalsburg, Chestertown, Rock Hall, Grasonville, and Queenstown. We also serve Annapolis, Salisbury, and Kent Island residents who prefer our expedited service.",
  howItWorksIntro: "Most Easton travelers complete everything online and ship documents overnight. No need to make the 1.5–2 hour trip across the Bay Bridge to downtown DC.",
  mistakesIntro: "Easton is a charming Eastern Shore town with a waterfront community and historic district. Here are the most common passport mistakes we see from Easton and Talbot County travelers.",
  testimonialsIntro: "Easton travelers — from waterfront residents to Eastern Shore families to historic district homeowners — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Easton, MD? Here are the most common ones we hear from Talbot County and Eastern Shore travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for Eastern Shore families and waterfront travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive ~2 hours across the Bay Bridge to DC", "Full day commitment — challenging for Eastern Shore residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Easton travelers with immediate departure needs — as fast as 24 hours. Essential for Eastern Shore residents who cannot afford the long trip to DC.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "No Bay Bridge traffic required"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Easton adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Easton address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Easton residents and families — including waterfront homeowners and seasonal residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Easton residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Easton families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Easton residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Easton MD", description: "Urgent passport processing for Easton Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Easton MD", description: "Fast passport renewal for Easton Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Easton MD", description: "New passport application services for Easton Maryland residents applying for their first passport." },
    { name: "Child Passport Easton MD", description: "Minor passport services for Easton Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Margaret C.",
      location: "Easton, MD",
      rating: 5,
      text: "Trip to Ireland with 10 days notice. Fast Passport Center processed my renewal in 4 days. No Bay Bridge crossing, no DC traffic — just shipped from our local UPS and it was done.",
      service: "Passport Renewal",
    },
    {
      name: "James H.",
      location: "St. Michaels, MD",
      rating: 5,
      text: "Family sailing trip to the Caribbean with 8 days notice. They coordinated passports for all five of us. Professional service that understands the Eastern Shore lifestyle.",
      service: "Family Passport Bundle",
    },
    {
      name: "Linda R.",
      location: "Oxford, MD",
      rating: 5,
      text: "Lost my passport before a trip to London. They had a replacement in my hands in 36 hours. I didn't have to drive across the bridge — just shipped overnight.",
      service: "Lost Passport Replacement",
    },
    {
      name: "David K.",
      location: "Trappe, MD",
      rating: 5,
      text: "Business trip to Frankfurt with 7 days notice. They reviewed my application, fixed a small issue, and delivered my passport in 48 hours. Essential for Eastern Shore professionals.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "easton-1",
      name: "Easton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "116 E Dover St",
      city: "Easton",
      state: "MD",
      zip: "21601",
      phone: "(410) 822-4613",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Easton, on Dover Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Easton acceptance facility. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "easton-2",
      name: "Cambridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 High St",
      city: "Cambridge",
      state: "MD",
      zip: "21613",
      phone: "(410) 228-4421",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Cambridge, approximately 15 miles south of Easton via US-50",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Dorchester County and southern Talbot County residents. Call to confirm current hours.",
      icon: "ri-mail-line",
    },
    {
      id: "easton-3",
      name: "Talbot County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "11 N Washington St",
      city: "Easton",
      state: "MD",
      zip: "21601",
      phone: "(410) 822-2611",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Easton, near the courthouse",
      website: "https://www.talbotcounty-md.gov/",
      websiteLabel: "Talbot County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations.",
      icon: "ri-government-line",
    },
    {
      id: "easton-4",
      name: "Chestertown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "104 S Cross St",
      city: "Chestertown",
      state: "MD",
      zip: "21620",
      phone: "(410) 778-2521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chestertown, approximately 20 miles northeast of Easton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Kent County and northern Eastern Shore residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2-hour drive across Bay Bridge to DC", fpc: "No — ship from Easton" },
    { feature: "Eastern Shore Support", agency: "No flexibility for remote area needs", fpc: "Yes — we specialize in Eastern Shore service" },
    { feature: "Chesapeake Bay Waterfront", agency: "No sailing community expertise", fpc: "Yes — waterfront and sailing travel specialists" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Seasonal Resident Travel", agency: "No seasonal scheduling flexibility", fpc: "Yes — seasonal and second-home owner support" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Easton's Eastern Shore location means the nearest passport agency is 2 hours away across the Bay Bridge. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Easton sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Easton and Talbot County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Easton Post Office appointments fill up fast. Book 2–3 weeks ahead — especially in summer when Chesapeake Bay travel is at its peak.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over, which is especially costly when you live on the Eastern Shore.",
    },
    {
      icon: "ri-alert-line",
      title: "Forgetting to Account for the Bay Bridge",
      description: "Many Eastern Shore residents think they can just drive to the DC passport agency. With the Bay Bridge and traffic, this is a 2-hour trip each way. Use Fast Passport Center's courier service instead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Easton, St. Michaels, or Oxford." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location in Easton or along US-50." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Eastern Shore address — no Bay Bridge crossing required." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Easton, MD?", a: "Fast Passport Center offers emergency passport processing in Easton, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency — without you needing to make the 2-hour drive across the Bay Bridge to DC. This is especially valuable for Eastern Shore residents." },
    { q: "Does Easton have its own passport agency?", a: "No — neither Easton nor the state of Maryland has a regional passport agency. The nearest facility is the Washington DC Passport Agency, approximately 1.5–2 hours away via US-50 W and the Bay Bridge. Fast Passport Center's courier service is essential for Eastern Shore residents who cannot afford this long trip." },
    { q: "Can I get expedited passport services if I live in St. Michaels or Oxford?", a: "Absolutely. Fast Passport Center serves all of the Easton area including St. Michaels, Oxford, Trappe, Cambridge, Hurlock, Denton, and Preston. We also serve Kent County residents in Chestertown and Rock Hall. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Easton, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Easton travelers use for international flights?", a: "Most Easton residents fly internationally through Baltimore-Washington International (BWI), approximately 1.5 hours west via US-50. Washington Dulles (IAD) is approximately 1.75 hours west via US-50. Philadelphia International (PHL) is approximately 2 hours north via US-301 and I-95. The Easton Airport (ESN) is a general aviation airport. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Easton?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Easton, St. Michaels, Oxford, and surrounding Eastern Shore communities. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Easton?", a: "The Easton Post Office at 116 E Dover St is the primary downtown acceptance facility. The Cambridge Post Office at 201 High St serves southern Dorchester County. The Chestertown Post Office at 104 S Cross St serves Kent County. The Talbot County Clerk's Office at 11 N Washington St also provides passport acceptance. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks. For Eastern Shore residents, the courier service is especially important — the Bay Bridge makes last-minute trips to DC very impractical." },
  ],
  photoLocations: [
    { name: "Walgreens — Easton", address: "219 Marlboro Ave, Easton, MD 21601", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Easton", address: "210 Marlboro Ave, Easton, MD 21601", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "UPS Store — Easton", address: "101 Marlboro Ave, Easton, MD 21601", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–4PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx — Easton", address: "24901 N Patuxent Blvd, Easton, MD 21601", hours: "Mon–Fri: 8AM–8PM, Sat: 9AM–5PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — Easton", address: "2900 Shore Hwy, Easton, MD 21601", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Talbot County and the Eastern Shore. REAL ID processing available.", featured: true },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "Approximately 1.5 hours from Easton via US-50 W",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary departure airport for Easton travelers. Southwest Airlines hub with direct flights to major US cities and international connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "Approximately 1.75 hours from Easton via US-50 W",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for international flights and United Airlines hub connections.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
    {
      code: "PHL",
      name: "Philadelphia International",
      distance: "Approximately 2 hours from Easton via US-301 N and I-95 N",
      address: "8000 Essington Ave, Philadelphia, PA 19153",
      note: "Alternative for international flights and American Airlines hub connections.",
      flightUrl: "https://www.phl.org/",
      flightLabel: "PHL Flight Info",
      featured: false,
    },
  ],
};